////////LIBRARY/////////
import update from 'immutability-helper'
import _, { cloneDeep, reject, map, isUndefined, isEmpty } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const kioskPerimeter = {
	[ActionsTypes.GET_PERIMETERS]: (state) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: true,
				},
				kioskPerimeterDetail: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_PERIMETERS_SUCCESS]: (state, payload) => {
		let perimeters = []
		map(payload.perimeters, (elem, _id) => {
			perimeters.push({ value: elem.id, label: elem.labelToDisplay })
		})
		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: perimeters,
				},
			},
		})
	},
	[ActionsTypes.GET_PERIMETERS_FAILURE]: (state, payload) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_PERIMETER]: (state) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				kioskPerimeterDetail: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_PERIMETER_SUCCESS]: (state, payload) => {
		let kioskPerimeterDetail = cloneDeep(state.kioskPerimeter.kioskPerimeterDetail)
		if (!kioskPerimeterDetail) {
			// Prepping the object if false (=> empty)
			kioskPerimeterDetail = {}
		}
		let userTags = cloneDeep(state.user.identity.tags.tags)

		kioskPerimeterDetail.kiosksInScope = payload.perimeter.kiosksInScope
		kioskPerimeterDetail.criterionsSelection = payload.perimeter.criterionsSelection

		if (!isEmpty(kioskPerimeterDetail.tags)) {
			map(kioskPerimeterDetail.tags, (elem) => {
				const f = _.find(userTags, (o) => o.id === elem.id) // Search in user tags
				const f2 = _.find(payload.perimeter.tags, (o) => o.id === elem.id) // Search in payload
				if (!isUndefined(f) || !isUndefined(f2)) {
					elem.selected = true
				}
				elem.selected = false
			})
		}
		kioskPerimeterDetail.id = payload.perimeter.id
		kioskPerimeterDetail.staticScope = payload.perimeter.staticScope

		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				kioskPerimeterDetail: {
					$set: kioskPerimeterDetail,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_PERIMETER_FAILURE]: (state, payload) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSKS_WITH_CRITERIA]: (state) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_KIOSKS_WITH_CRITERIA_SUCCESS]: (state, payload) => {
		let kioskPerimeterDetail = cloneDeep(state.kioskPerimeter.kioskPerimeterDetail)

		if (!kioskPerimeterDetail) {
			// Prepping the object if false (=> empty)
			kioskPerimeterDetail = {}
		}
		kioskPerimeterDetail.kiosksInScope = payload.kiosks
		//kioskPerimeterDetail.tags = state.user.identity.tags.tags
		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				kioskPerimeterDetail: {
					$set: kioskPerimeterDetail,
				},
				error: {
					$set: false,
				},
			},

			toastSuccess: {
				show: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSKS_WITH_CRITERIA_FAILURE]: (state, payload) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_LIST_TAGS]: (state) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_LIST_TAGS_SUCCESS]: (state, payload) => {
		let kioskPerimeterDetail = cloneDeep(state.kioskPerimeter.kioskPerimeterDetail)

		let userTags = cloneDeep(state.user.identity.tags.tags)

		if (!kioskPerimeterDetail) {
			// Prepping the object if false (=> empty)
			kioskPerimeterDetail = {}
		}
		kioskPerimeterDetail.tags = payload.tags.tags
		if (!isEmpty(kioskPerimeterDetail.tags) && !isEmpty(userTags)) {
			map(kioskPerimeterDetail.tags, (elem) => {
				const f = _.find(userTags, (o) => o.id === elem.id)
				if (!isUndefined(f)) {
					elem.selected = true
				}
				elem.selected = false
			})
		}

		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				kioskPerimeterDetail: {
					$set: kioskPerimeterDetail,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_LIST_TAGS_FAILURE]: (state, payload) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_KIOSKS_SCOPE]: (state) => {
		return update(state, {
			kioskPerimeter: {
				kioskPerimeterDetail: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.CREATE_PERIMETER]: (state) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_PERIMETER_SUCCESS]: (state, payload) => {
		const kiosksSelected = payload.perimeter.kiosksInScope
		const idPerimeter = payload.perimeter.id
		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				kioskPerimeterDetail: {
					$set: false,
				},
			},
			user: {
				identity: {
					kioskSelected: {
						$set: kiosksSelected,
					},
					idPerimeter: {
						$set: idPerimeter,
					},
				},
			},
		})
	},
	[ActionsTypes.CREATE_PERIMETER_FAILURE]: (state, payload) => {
		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.APPLY_PERIMETER]: (state, payload) => {
		let kiosksSelected = payload.perimeter.kiosks
		const idPerimeter = payload.idPerimeter

		return update(state, {
			kioskPerimeter: {
				update: {
					$set: true,
				},
				kioskPerimeterDetail: {
					$set: false,
				},
			},
			user: {
				identity: {
					kioskSelected: {
						$set: kiosksSelected,
					},
					idPerimeter: {
						$set: idPerimeter,
					},
				},
			},
		})
	},
	[ActionsTypes.UPDATE_PERIMETER]: (state) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_PERIMETER_SUCCESS]: (state, payload) => {
		let kiosksSelected = payload.perimeter.kiosksInScope
		const idPerimeter = payload.perimeter.id
		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				kioskPerimeterDetail: {
					$set: false,
				},
			},
			user: {
				identity: {
					kioskSelected: {
						$set: kiosksSelected,
					},
					idPerimeter: {
						$set: idPerimeter,
					},
				},
			},
		})
	},
	[ActionsTypes.UPDATE_PERIMETER_FAILURE]: (state, payload) => {
		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.DELETE_PERIMETER]: (state) =>
		update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: true,
				},
				deleteSuccess: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.DELETE_PERIMETER_SUCCESS]: (state, payload) => {
		// Removing from list
		let oldPerimeters = cloneDeep(state.kioskPerimeter.items)
		const idPerimeter = payload.idPerimeter

		oldPerimeters = reject(oldPerimeters, { value: idPerimeter })

		// But also clearing kioskListSelected and idPerimeter of user store
		// if his perimeter was the deleted one
		let idUserPerimeter = state.user.identity.idPerimeter
		let kiosksSelected = state.user.identity.kioskSelected

		if (payload.idPerimeter === idUserPerimeter) {
			idUserPerimeter = 0
			kiosksSelected = state.user.identity.kiosksPool
		}

		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: [...oldPerimeters],
				},
				error: {
					$set: false,
				},
				deleteSuccess: {
					$set: true,
				},
				kioskPerimeterDetail: {
					$set: false,
				},
			},
			user: {
				identity: {
					idPerimeter: {
						$set: idUserPerimeter,
					},
					kioskSelected: {
						$set: kiosksSelected,
					},
				},
			},
		})
	},
	[ActionsTypes.DELETE_PERIMETER_FAILURE]: (state, payload) => {
		return update(state, {
			kioskPerimeter: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
}

export default kioskPerimeter
